import React from "react";
import { useTranslation } from "react-i18next";
import nexarLogo from "../../core/assets/logo.png";
import Event from "../../core/consts/analytics-events";
import styles from "./header.module.scss";
import { useDI } from "../../core/di";

interface Props {
  user?: { firstName?: string };
  onLogout?: () => void;
}

export default function Header(props: Props) {
  const { onLogout, user } = props;
  const { t } = useTranslation();
  const { analytics } = useDI();

  const handleLogout = () => {
    analytics?.track(Event.HeaderLogout);
    onLogout?.();
  };

  const leftSection = () => {
    return (
      <div className={styles.LeftSection}>
        <img src={nexarLogo} height="18px" alt="nexar-logo" />
      </div>
    );
  };

  const rightSection = () => {
    return (
      <div className={styles.RightSection}>
        {user?.firstName && (
          <span data-testid={"header-hi"}>
            {t("hi", { username: user?.firstName })}
          </span>
        )}
        {user?.firstName && onLogout && " "}
        {onLogout && (
          <button
            onClick={handleLogout}
            className={styles.Logout}
            data-testid={"header-logout"}
          >
            {t(!user?.firstName ? "Logout" : "logout")}
          </button>
        )}
      </div>
    );
  };

  return (
    <header className={styles.Wrapper}>
      <div className={styles.Container}>
        {leftSection()}
        {user && rightSection()}
      </div>
    </header>
  );
}
